import {
	type InfiniteData,
	type UndefinedInitialDataInfiniteOptions,
	useInfiniteQuery,
} from "@tanstack/react-query";
import {
	limit,
	makeOffsetInfiniteQueryOptions,
	useResetInfiniteData,
} from "web_myplann/Api/Notifications/infiniteQueryUtils";
import { NotificationsKeys } from "web_myplann/Api/Notifications/notificatioKeys";
import {
	getNotificationsGroupedV2,
	type NotificationGroupEnum,
	type NotificationListResponseDTO,
	type NotificationTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

type Key = ReturnType<typeof NotificationsKeys.infiniteGroupedList>;

export const getNotificationsGroupedInfiniteOptions = (
	filterOnlyunread?: boolean,
	filterExcludetypes?: NotificationTypeEnum[],
	filterGroups?: NotificationGroupEnum[],
	filterDaygroupactive?: boolean,
): UndefinedInitialDataInfiniteOptions<
	NotificationListResponseDTO,
	Error,
	InfiniteData<NotificationListResponseDTO, number>,
	Key,
	number
> => ({
	queryKey: NotificationsKeys.infiniteGroupedList(filterOnlyunread),
	queryFn: (ctx) =>
		processResponseQuery(() =>
			getNotificationsGroupedV2(
				filterOnlyunread,
				filterExcludetypes,
				filterGroups,
				filterDaygroupactive,
				limit,
				ctx.pageParam,
			),
		)(ctx),
	...makeOffsetInfiniteQueryOptions((meta) =>
		filterOnlyunread ? meta?.unreadCount : meta?.totalCount,
	),
	placeholderData: (prev) => prev,
});

export const useNotificationsGroupedQuery = (
	filterOnlyunread?: boolean,
	filterExcludetypes?: NotificationTypeEnum[],
	filterGroups?: NotificationGroupEnum[],
	filterDaygroupactive?: boolean,
) => {
	useResetInfiniteData(NotificationsKeys.infiniteGroupedList(filterOnlyunread));

	return useInfiniteQuery(
		getNotificationsGroupedInfiniteOptions(
			filterOnlyunread,
			filterExcludetypes,
			filterGroups,
			filterDaygroupactive,
		),
	);
};
